import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lib-dast-renderer',
  templateUrl: './dast-renderer.component.html',
  styleUrls: ['./dast-renderer.component.scss']
})
export class DastRendererComponent implements OnInit {
  @Input() dastNode: any;

  constructor() { }

  ngOnInit(): void {
  }

}
